import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["href", "target"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_item_section = _resolveComponent("q-item-section");
    const _component_q_item = _resolveComponent("q-item");
    const _component_router_link = _resolveComponent("router-link");
    const _component_q_list = _resolveComponent("q-list");
    const _component_q_menu = _resolveComponent("q-menu");
    return (_openBlock(), _createBlock(_component_q_menu, null, {
        default: _withCtx(() => [
            _createVNode(_component_q_list, { class: "st-min-wh-100" }, {
                default: _withCtx(() => [
                    _createVNode(_component_q_item, {
                        clickable: "",
                        onClick: _ctx.hideFAB,
                        "aria-label": "Hide"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_item_section, { side: "" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                        name: "not_interested",
                                        color: "negative",
                                        size: "1rem"
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createTextVNode(" Hide ")
                                ])),
                                _: 1,
                                __: [1]
                            })
                        ]),
                        _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_router_link, {
                        to: { name: 'Contact Us' },
                        custom: ""
                    }, {
                        default: _withCtx(({ href }) => [
                            _createElementVNode("a", {
                                href: href,
                                target: _ctx.styleType === 'app' ? '' : '_blank',
                                "aria-label": "Contact Us"
                            }, [
                                _createVNode(_component_q_item, { clickable: "" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_q_item_section, { side: "" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_icon, {
                                                    name: "description",
                                                    color: "accent",
                                                    size: "1rem"
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_q_item_section, null, {
                                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                _createTextVNode(" Contact Us ")
                                            ])),
                                            _: 1,
                                            __: [2]
                                        })
                                    ]),
                                    _: 1
                                })
                            ], 8, _hoisted_1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_item, {
                        clickable: "",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.goexturl('whatsapp'))),
                        "aria-label": "WhatsApp Us"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_item_section, { side: "" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                        name: "font-custom-whatsapp",
                                        color: "green-5",
                                        size: "1rem"
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                    _createTextVNode(" Whatsapp ")
                                ])),
                                _: 1,
                                __: [3]
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            })
        ]),
        _: 1
    }));
}
